import { render, staticRenderFns } from "./UnionList.vue?vue&type=template&id=2bb5c278&scoped=true"
import script from "./UnionList.vue?vue&type=script&lang=js"
export * from "./UnionList.vue?vue&type=script&lang=js"
import style0 from "./UnionList.vue?vue&type=style&index=0&id=2bb5c278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5c278",
  null
  
)

export default component.exports